import {convertRESTToWarehouseParameters} from 'insights/parameters/data/ParameterRESTConverters';
import {
  AnalyticsParameterConfigSpecRequest,
  RESTAnalyticsParameterValue,
} from 'insights/parameters/RESTParameterTypes';
import * as Perf from 'performance/Perf';
import * as TaskRunner from 'util/TaskRunner';

export interface ValidInferSQLResponse {
  approach: string;
  suggestedSQL: string;
  isValid: true;
  queryPlan: string;
  traceId: string;
}

export interface InvalidInferSQLResponse {
  approach: string;
  suggestedSQL: string;
  isValid: false;
  sqlError: string;
  traceId: string;
}

export type InferSQLResponse = ValidInferSQLResponse | InvalidInferSQLResponse;

export async function inferSQL(
  sqlQuery: string,
  parameterConfigs: Array<AnalyticsParameterConfigSpecRequest>,
  parameterValues: Array<RESTAnalyticsParameterValue>
): Promise<InferSQLResponse> {
  const perfId = Perf.start('llm.ai_sql.user_latency_ms', {enabled: false}) ?? '';
  Perf.markStart(perfId);

  const response = await TaskRunner.postJSONPromise({
    url: '/1/api/insights/ai-assistant:suggest-dashboard-sql',
    data: {
      parameterizedSQLQuery: sqlQuery,
      // usually we only send parameters that are actually used in the query
      // but here we send all parameters to the AI assistant so it has the full context
      parameters: convertRESTToWarehouseParameters(parameterConfigs, parameterValues),
    },
  });

  Perf.markEnd(perfId);
  Perf.stop(perfId);

  return response;
}
